module.exports = __webpack_public_path__ + "img/category-management-icon7.31731179.svg";